/**
 * product-card-atc.js
 * ====================
 * Tento soubor nahrazuje inline <script> z product-item.liquid.
 * Vložte ho do assets/ ve vašem Shopify theme a načtěte jednou
 * v theme.liquid nebo v layout souboru:
 *
 *   <script src="{{ 'product-card-atc.js' | asset_url }}" defer></script>
 *
 * Klíčový rozdíl: místo opakování v každé kartě se inicializuje
 * jednou pomocí event delegation na documentu.
 */
(function () {
  if (window._atcDelegated) return;
  window._atcDelegated = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-atc]');
    if (!btn || btn.disabled) return;

    e.preventDefault();

    var id = btn.getAttribute('data-atc');
    var originalLabel = btn.getAttribute('data-atc-label') || btn.textContent;
    var addedLabel = btn.getAttribute('data-atc-added') || '✓ Přidáno do košíku';
    var sideCartEl = document.querySelector('#cart');
    var sideCartId = sideCartEl ? sideCartEl.getAttribute('data-section-id') : '';

    // Najdi dostupnost z product card badge
    var card = btn.closest('.product-card, li');
    var avEl = card ? card.querySelector('.product-availability') : null;
    var bodyData = {
      id: parseInt(id),
      quantity: 1,
      sections: sideCartId ? [sideCartId] : []
    };
    if (avEl) {
      bodyData.properties = { "Dostupnost": avEl.textContent.trim() };
    }

    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(bodyData)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = addedLabel;

        // Otevři side cart
        if (typeof showPanel === 'function') {
          showPanel('cart');
        } else if (typeof window.showPanel === 'function') {
          window.showPanel('cart');
        } else {
          var cartLink = document.querySelector('[data-panel="cart"]');
          if (cartLink) cartLink.click();
        }

          if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
          window.ajaxCart.load(false, false, false, true);
        }

        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (c) {
            document.querySelectorAll('.cart-count').forEach(function (el) {
              el.innerHTML = c.item_count;
              el.classList.remove('hidden');
            });
          });

        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalLabel;
        }, 2000);
      })
      .catch(function () {
        var card = btn.closest('.product-card');
        var link = card ? card.querySelector('a') : null;
        if (link) {
          window.location.href = link.href;
        }
      });
  });
})();